import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";

import ApolloProvider from "./common/apollo";

import momentInit from "./utils/moment";
import { ENV } from "./utils/getEnv";

momentInit();

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={ENV.AUTH0_DOMAIN}
      clientId={ENV.AUTH0_CLIENT}
      scope="openid"
      redirectUri={window.location.origin}
    >
      <ApolloProvider>
        <App />
      </ApolloProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
